export enum EnvironmentType {
  Production = 'production',
  Test = 'test'
}



// WEBPACK FOOTER //
// ./src/shared/enum/environmentType.ts